import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-accessibility-statement',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.scss']
})
export class AccessibilityStatementComponent {

  public baseURL;
  public login;
  public home;
  public gestionGAE;
  public habilitationCL;
  public profile;
  public contrat;

  public formulaireSaisine;
  public carteDelegues;

  constructor() {
    this.baseURL = `https://${window.location.host}/`;

    // local links
    this.login = `${this.baseURL}login`;
    this.home = `${this.baseURL}home`;
    this.gestionGAE = `${this.baseURL}gestion/gae`;
    this.habilitationCL = `${this.baseURL}habilitation/cl`;
    this.profile = `${this.baseURL}profile`;
    this.contrat = `${this.baseURL}contrat`;

    // configured links
    this.formulaireSaisine = environment.ACCESSIBILITY_STATEMENT_FORMULAIRE_SAISINE_URL;
    this.carteDelegues = environment.ACCESSIBILITY_STATEMENT_CARTE_DELEGUES_URL;
  };

}
